import { MessageModel } from "./option/message.model";
import { EMessageLevel } from "./option/message-level.e";

export abstract class MessageService {
	abstract present(message: MessageModel, level?: EMessageLevel);
	abstract dismiss(messageId: any);
}
